export const primary = '#4BD1A0';
